import React, { useState } from "react";
import PropTypes from "prop-types";
import { Grid, Card, Step, StepLabel, Stepper } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Footer from "examples/Footer";
import Header from "layouts/pages/profile/components/Header2";
import About from "./components/About";
import Configure from "./components/Configure";

const steps = ["Überblick", "Konfiguration"];

function getStepContent(stepIndex, handleNext, handleBack, productType) {
  switch (stepIndex) {
    case 0:
      return <About onNext={handleNext} productType={productType} />;
    case 1:
      return <Configure productType={productType} onBack={handleBack} />;
    default:
      return "Unknown step";
  }
}

function SaasProductWizard({ productType }) {
  const [activeStep, setActiveStep] = useState(0);

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  return (
    <DashboardLayout>
      <Header />
      <SoftBox py={3} mb={20} minHeight="65vh">
        <Grid container justifyContent="center">
          <Grid item xs={12} lg={8}>
            <SoftBox mt={6} mb={8} textAlign="center">
              <SoftTypography variant="h3" fontWeight="bold">
                {productType === 'backup-now' && 'UDS Backup Now'}
                {productType === 'office-365' && 'MS Office 365'}
                {productType === 'tsplus' && 'TSPlus'}
                {productType === 'eset' && 'ESET Security'}
                {productType === 'lastpass' && 'Lastpass'}
                {productType === 'nextcloud' && 'Nextcloud'}
              </SoftTypography>
            </SoftBox>

            <Stepper activeStep={activeStep} alternativeLabel>
              {steps.map((label) => (
                <Step key={label}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>
            <Card>
              <SoftBox p={2}>
                <SoftBox>
                  {getStepContent(activeStep, handleNext, handleBack, productType)}
                </SoftBox>
              </SoftBox>
            </Card>
          </Grid>
        </Grid>
      </SoftBox>
      <Footer />
    </DashboardLayout>
  );
}

SaasProductWizard.propTypes = {
  productType: PropTypes.oneOf(['backup-now', 'office-365', 'tsplus', 'eset', 'lastpass', 'nextcloud']).isRequired,
};

export default SaasProductWizard;